module.exports = __webpack_public_path__ + "meural-logo-bronze.png";